<div class="modal-header main-modal-header">
    <h4 class="modal-title wrap-text-in">
        <span *ngIf="deleteContactUserInfo.activityType !== 'removePrimaryContact'">Remove Contact</span>
        <span
            *ngIf="deleteContactUserInfo.activityType === 'removePrimaryContact'">{{deleteContactUserInfo.activityTitle}}</span>
    </h4>
</div>

<div class="modal-body">
    <div class="row" *ngIf="deleteContactUserInfo.activityType === 'removePrimaryContact'">
        <div class="col-xs-12">
            <p class="px-3">{{deleteContactUserInfo.activityMessage}}</p>
        </div>
        <div class="col-xs-6 col-sm-4 px-3" *ngIf="deleteContactUserInfo.contactsList.length > 0">
            <div class="form-group" [ngClass]="{'has-error': isSaveClicked && !selectedExistingContact}">
                <label for="existingUser" class="control-label">
                    Existing Contacts
                    <em> * </em> :
                </label>
                <select class="form-control" name="existingUser" id="existingUser"
                    [(ngModel)]="selectedExistingContact" (ngModelChange)="existingUserChanged()">
                    <option *ngFor="let user of deleteContactUserInfo.contactsList" [ngValue]="user">{{user.name}}</option>
                </select>
            </div>
        </div>
    </div>
    <div class="form-group wrap-text-in" *ngIf="deleteContactUserInfo.activityType !== 'removePrimaryContact'">
        <p>
            This contact has been designated as a POC on Requisition(s). The POC on the Requisition(s) has to be replaced with another valid POC before this contact can be deleted.
        </p>
        <p>
            This contact is on following requisition(s).
        </p>
        <div class="table-responsive" style="margin-top:10px">
            <table class="table" id="requisitionsTable">
                <thead>
                    <tr>
                        <th class="text-center border">
                            S No
                        </th>
                        <th class="text-center border">
                            Requisition #
                        </th>
                        <th class="text-center border">
                            Title
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let requisition of deleteContactUserInfo.requisitionDetails; let i = index">
                        <td class="text-center border">
                            <div>{{i+1}}</div>
                        </td>
                        <td class="text-center border">
                            <div>{{requisition.requisitionNumber}}</div>
                        </td>
                        <td class="text-center border">
                            <span>{{requisition.jobTitle}}</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <p>
        </p>
    </div>
</div>

<div class="modal-footer">
    <div *ngIf="deleteContactUserInfo.activityType === 'removePrimaryContact'">
        <button *ngIf="deleteContactUserInfo.contactsList.length > 0" type="button" class="btn btn-danger mr-2"
            (click)="dismissModal()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="removeContact()">
            <span *ngIf="deleteContactUserInfo.contactsList.length > 0">Remove</span>
            <span *ngIf="deleteContactUserInfo.contactsList.length === 0">Ok</span>
        </button>
    </div>
    <div *ngIf="deleteContactUserInfo.activityType !== 'removePrimaryContact'">
        <button type="button" class="btn btn-primary" (click)="closeModal()">Ok</button>
    </div>
</div>
